module.exports = __webpack_public_path__ + "img/investor.399036c1.png";